
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mega-sell",
      function () {
        return require("private-next-pages/mega-sell/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mega-sell"])
      });
    }
  